import { useState } from "react";
import { ScrollReveal } from "./ScrollReveal";

const tools = [
  { id: "nexis-ai", label: "Nexis AI", accent: "#8B5CF6", mockup: "/mockups/mockup-nexis-ai.png", description: "AI writes your scripts, generates video ideas, creates image and video prompts, and produces fully optimised YouTube titles and descriptions." },
  { id: "monetisation-ai", label: "Monetisation AI", accent: "#F97316", mockup: "/mockups/mockup-monetisation-ai.png", description: "Analyses your niche and audience, then builds your complete digital product in one click — ebook, course, template pack, or newsletter." },
  { id: "keyword-research", label: "Keyword Research", accent: "#06B6D4", mockup: "/mockups/mockup-keyword-research.png", description: "Find what your audience is searching for right now. Updated daily. Surface the highest-opportunity topics in your niche." },
  { id: "askfint", label: "AskFint", accent: "#10B981", mockup: "/mockups/mockup-askfint.png", description: "Your personal AI business advisor. Ask anything about monetisation, content strategy, or product launches." },
  { id: "email-list-builder", label: "Email List Builder", accent: "#EC4899", mockup: "/mockups/mockup-email-list-builder.png", description: "Creates your lead magnet, opt-in page, and welcome email sequence — all generated from your niche." },
  { id: "sales-page-builder", label: "Sales Page Builder", accent: "#EAB308", mockup: "/mockups/mockup-sales-page-builder.png", description: "Generates your complete sales page from the product the AI just built. Copy, layout, and CTA — all done." },
  { id: "launch-advisor", label: "Launch Advisor", accent: "#6366F1", mockup: "/mockups/mockup-launch-advisor.png", description: "Get a step-by-step launch plan personalised to your audience size, niche, and product type." },
  { id: "clip-ai", label: "Clip AI", accent: "#EF4444", mockup: "/mockups/mockup-clip-ai.png", description: "Turn long-form content into short-form clips with captions burned in — ready for TikTok, Reels, and Shorts." },
];

export const FeaturesSection = () => {
  const [activeTab, setActiveTab] = useState(0);
  const active = tools[activeTab];

  return (
    <section id="features" className="py-12 md:py-24 relative" style={{ background: "#FFFFFF" }}>
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <ScrollReveal>
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-display font-bold mb-3" style={{ color: "#111827", fontSize: "clamp(24px, 3.5vw, 40px)", lineHeight: 1.2 }}>
              Everything you need to grow your creator business
            </h2>
            <p className="text-sm md:text-lg max-w-2xl mx-auto" style={{ color: "#4B5563" }}>
              8 AI-powered tools. One platform. Zero guesswork.
            </p>
          </div>
        </ScrollReveal>

        {/* Tab buttons */}
        <div className="overflow-x-auto scrollbar-hide -mx-4 px-4 md:mx-0 md:px-0 mb-10 md:mb-14">
          <div className="flex gap-2 md:justify-center min-w-max md:min-w-0">
            {tools.map((tool, i) => {
              const isActive = activeTab === i;
              return (
                <button
                  key={tool.id}
                  onClick={() => setActiveTab(i)}
                  className="px-4 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200"
                  style={{
                    background: isActive ? `${tool.accent}15` : "#F3F4F6",
                    color: isActive ? tool.accent : "#6B7280",
                    border: isActive ? `1.5px solid ${tool.accent}` : "1px solid #E5E7EB",
                    transform: isActive ? "translateY(-2px)" : "translateY(0)",
                    boxShadow: isActive ? `0 4px 12px ${tool.accent}20` : "none",
                  }}
                >
                  {tool.label}
                </button>
              );
            })}
          </div>
        </div>

        {/* Tab content */}
        <ScrollReveal>
          <div className="max-w-[900px] mx-auto">
            <div className="rounded-2xl p-6 md:p-8 bg-white transition-all duration-300" style={{ border: "1px solid #E5E7EB", boxShadow: "0 4px 24px rgba(0,0,0,0.04)" }}>
              <div className="text-center mb-6">
                <h3 className="font-display text-xl md:text-2xl font-bold mb-2" style={{ color: "#111827" }}>
                  {active.label}
                </h3>
                <p className="text-sm md:text-base max-w-xl mx-auto" style={{ color: "#4B5563" }}>
                  {active.description}
                </p>
              </div>
              {tools.map((tool, i) => (
                <img
                  key={tool.id}
                  src={tool.mockup}
                  alt={tool.label}
                  className="w-full object-contain rounded-xl"
                  style={{
                    display: activeTab === i ? "block" : "none",
                    border: "1px solid #E5E7EB",
                  }}
                  loading="lazy"
                />
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
